import type { AssetType } from '../../../../../utils/storage';

interface FooterQr {
    media: AssetType;
    logo: AssetType;
    title: string;
}

export default function FooterQr({ media, logo, title }: FooterQr) {
    return (
        <div
            style={{
                position: 'absolute',
                bottom: '4.17vh', // 80
                left: '2.6vh', // 50
            }}
        >
            <div
                style={{
                    display: 'flex',
                    gap: '0.83vh', // 16
                }}
            >
                {
                    logo && (
                        <div
                            style={{
                                width: '7.29vh', // 140
                                height: '7.29vh', // 140
                                padding: 0,
                                background: 'white',
                                borderRadius: '0.78vh', // 15
                            }}
                        >
                            <img
                                src={logo.url}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    borderRadius: '0.78vh', // 15
                                }}
                            />
                        </div>
                    )
                }

                {
                    media && (
                        <div
                            style={{
                                width: '7.29vh', // 140
                                height: '7.29vh', // 140
                                padding: '0.26vh', // 5
                                background: 'white',
                                borderRadius: '0.78vh', // 15
                            }}
                        >
                            <img
                                src={media.url}
                                style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                            />
                        </div>
                    )
                }
            </div>

            <div
                style={{
                    textTransform: 'uppercase',
                    fontSize: '1.67vh', // 32
                    marginTop: '0.83vh', // 16
                    letterSpacing: '0.02em',
                    fontWeight: 500,
                    fontFamily: 'HelveticaNowDisplay'
                }}
            >
                {title}
            </div>
        </div>
    );
}
